import { classificationTabs } from './classification-tabs';
import { createFocusTrap } from './focus-trap';

export const teamMembers = () => {
    const teamMembersElem = document.querySelectorAll('.team-member');
    let trap: ReturnType<typeof createFocusTrap>;

    const openDetail = (detailElem: HTMLElement) => {
        if (trap?.active) return;
        detailElem.inert = false;
        detailElem.style.display = 'grid';
        detailElem.scrollTop = 0;
        const reflow = detailElem.offsetHeight;
        detailElem.classList.add('team-member__detail--active');
        trap = createFocusTrap(detailElem);
        trap.activate();
        detailElem.querySelector<HTMLElement>('.team-member__detail-controls[aria-label]')?.focus({ preventScroll: true });
    }

    const closeDetail = (detailElem: HTMLElement) => {
        detailElem?.classList.remove('team-member__detail--active');
        trap?.release();
        (detailElem.previousElementSibling as HTMLElement)?.focus({ preventScroll: true });
        detailElem.inert = true;
        Promise.all(
            detailElem.getAnimations({ subtree: true }).map((animation) => animation.finished),
        ).catch(() => {}).finally(() => {
            if (!detailElem.classList.contains('team-member__detail--active')) detailElem.style.display = 'none';
        });
    }

    teamMembersElem.forEach(t => {
        const detailElem = t.nextElementSibling as HTMLElement;
        
        if(!detailElem)
            return;

        const controlElem = detailElem.querySelectorAll('.team-member__detail-controls');

        detailElem.setAttribute('role', 'dialog');
        detailElem.setAttribute('aria-modal', 'true');
        detailElem.setAttribute('aria-label', detailElem.querySelector('h2')?.textContent?.trim() || 'Team profile');

        t.addEventListener('click', () => {
            if (!detailElem.classList.contains('team-member__detail--active')) {
                openDetail(detailElem);
            }
        })

        controlElem.forEach(c => {
            c.addEventListener('click', () => {
                if (detailElem.classList.contains('team-member__detail--active')) {
                    closeDetail(detailElem);
                }
            })
        })
    })

    document.addEventListener("keydown", function(e) {
        const detailElem = document.querySelector('.team-member__detail--active');

        if(e.key === "Escape" && detailElem) {
            closeDetail(detailElem as HTMLElement);
        }

        if ((e.target as HTMLElement)?.classList.contains('team-member') && 
                (e.key=="Enter" || e.key==" ") && 
                !detailElem?.classList.contains('team-member__detail--active')
            ) {
                e.preventDefault();
                const detail = (e.target as HTMLElement).nextElementSibling;
                if (detail)
                    openDetail(detail as HTMLElement);
        }
    });
    
    const detailOverlayElem = document.querySelectorAll('.team-member__detail-overlay');

    detailOverlayElem.forEach(overlay => {
        overlay.addEventListener('click', () => {
            const detailElem = overlay.parentElement;
            if (detailElem) {
                closeDetail(detailElem as HTMLElement);
            }
        });
    });

    classificationTabs('.team-member', '.team-member-listing', 'Team departments');
}
